module.exports = __webpack_public_path__ + "static/media/accutrans_logo.4d6597dc.svg";